import { Injectable } from '@angular/core';
import { VerificationLiteCreate, VerificationLite, GuestReportLite } from 'models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class VerificationLiteService {
    constructor(private http: HttpClient) {}

    public fetch(): Observable<VerificationLite[]> {
        return this.http.get<VerificationLite[]>(`api/verificationlite/fetch`);
    }

    public get(id: string): Observable<GuestReportLite> {
        return this.http.get<GuestReportLite>(`api/verificationlite/get/${id}`);
    }

    public verify(verificationLite: VerificationLiteCreate): Observable<string> {
        return (this.http.post<string>('api/verificationlite/verify', verificationLite));
    }
}
